import React, { useState } from 'react';
import { PassType } from '../../api';
import { ChoosePassType } from './ChoosePassType';
import { CreateStandardPassForm } from './CreateStandardPassForm';
import { CreateFixedSchedulePassForm } from './CreateFixedSchedulePassForm';

export const CreatePassOrderPage = () => {
  const [step, setStep] = useState(1);
  const [pickedType, setPickedType] = useState<PassType | undefined>();

  const handleBack = () => {
    setPickedType(undefined);
    setStep(1);
  };

  const handlePick = (passType: PassType) => {
    setPickedType(passType);
    setStep(2);
  };

  if (step === 1 || !pickedType) {
    return <ChoosePassType onPick={handlePick} />;
  }

  if (pickedType === PassType.FIXED_SCHEDULE_MONTHLY) {
    return <CreateFixedSchedulePassForm handleBack={handleBack} />;
  }

  return <CreateStandardPassForm passType={pickedType} handleBack={handleBack} />;
};
